<template>
  <div>
    <p class="has-text-centered ptb-2">{{ loadingText }}</p>
  </div>
</template>

<script>
export default {

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Loading…'
    }
  }

}
</script>